/**
 * SearchFilter — 사용자PC(/u/orders) 엑셀형 오더 테이블의 검색 + 필터 적용 코어.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 search / search_from_server / apply_filter /
 * keyword_delay_search / get_checked_search_opt_list / set_checked_search_opt_list 를 캡슐화했다.
 *
 *   - search()               : 검색범위 이내면 클라 필터링, 벗어나면 서버 재조회
 *   - searchFromServer()     : /u/ajax/order/list 로 날짜범위 조회 → orderTax 적재 → 렌더
 *   - applyFilter(isReset)   : orderTax.list 를 순회하며 TR 표시/숨김(컬럼필터+검색어)
 *   - keywordDelaySearch(e)  : 검색어 입력 디바운스 → search()
 *   - get/setCheckedSearchOptList : 상단 검색옵션 체크박스 상태를 쿠키에 저장/복원
 *
 * ⚠ 이관 범위 (코어만) — 필터 드롭다운 UI(filter_set/show_filterList/doSerch_Start/…)는
 *   미정의 함수(show_checked/set_itTo)·변수 셰도잉·다수 blade-write 결합이 있어 다음 슬라이스로 연기.
 *   그 함수들은 u-order-list.js 에 남아 window.applyFilter 등을 호출한다.
 *
 * 결합 — 모듈은 strict 이므로 전부 window.* 로 접근:
 *   - 데이터/렌더 : window.orderTax, window.render_order_all, window.get_order_payed_type,
 *                   window.toggle_checkbox_all (모두 u-order-list.js 잔류)
 *   - blade 전역   : window.showPriceTotal, window.boxOn_showCnt (apply 시 read/write), G5 (common.js const 전역)
 *   - 공통/레이아웃: window.number_format, window.setCookie, window.getCookie
 *
 * 진입점은 $j.Pages.Desktop.Orders.initialize() 가 레거시 전역명으로 window 브리지한다
 * (블레이드 onclick/onkeyup · __ordersPageBoot · u-order-list.js 잔류 함수가 호출).
 */
import Util from '../../../Common/Util';
import Store from '../../../Common/Store';
export default class SearchFilter {
    constructor() {
        this._kwdTimerId = undefined; // (구)kwd_timd_id : 검색어 디바운스 타이머
    }

    /** 통합 검색: 기존 범위 이내면 필터링, 벗어나면 서버 재조회 (구 search) */
    search = () => {
        this.getCheckedSearchOptList();

        // 기존 검색범위를 벗어났다면 => 서버요청
        if (!window.orderTax.start_date || !window.orderTax.end_date ||
            $('#start_date').val() < window.orderTax.start_date || $('#end_date').val() > window.orderTax.end_date) {
            this.searchFromServer();
        }
        // 기존 검색범위내에 있다면 => 필터링
        else {
            this.applyFilter(false);
        }
    }

    /** 서버에서 날짜범위 오더를 불러와 렌더 (구 search_from_server) */
    searchFromServer = () => {
        // 화면 초기화
        let html = `<tr id="trloadingfd"><td colspan=21 style="text-align:center; line-height:50px; "><br><br><Br><font style=""><br>데이터 로딩 중</font><br><br><img src="/img/m/pageloading_threedot.svg" style="height:20px"><br><br><Br></td></tr>`;
        $('#tableListUp').html(html);

        let start_date = $('#start_date').val();
        let end_date = $('#end_date').val();
        var adr = "/u/ajax/order/list?start_date=" + start_date + "&end_date=" + end_date;
        $.ajax({
            type: "get", url: adr, dataType: 'json', success: (order_list) => {
                window.orderTax.update_list(order_list); // 오더목록 데이터를 업데이트한다.
                window.orderTax.update_date(start_date, end_date); // 서버에서 검색했던 날짜 범위를 저장한다.
                window.render_order_all(); // 오더목록을 화면에 그려준다.
                $('#searchTot').on('keyup', this.keywordDelaySearch);// 검색어 입력시 필터링 되게 이벤트 처리
                window.toggle_checkbox_all();
            }
        });
    }

    /**
     * 검색조건에 해당되는 목록만 보여주기 (구 apply_filter)
     * @param is_reset 검색어 초기화 여부
     */
    applyFilter = (is_reset) => {
        if (is_reset) document.getElementById("searchTot").value = "";
        var keyword = document.getElementById("searchTot").value; // 검색어
        if (keyword.length < 1) {
            document.getElementById("resetserxbtn").style.display = "none";
        }

        window.showPriceTotal = 0; // 검색된 오더의 장비대금 합계
        window.boxOn_showCnt = 0; // 검색된 오더의 개수
        document.getElementById("resetserxbtn").style.display = "inline-block";

        // 모든 오더목록을 순회한다.
        window.orderTax.list.forEach((order_info, idx) => {
            let ordernum = order_info.onum;
            let trid = "tr_order_" + ordernum;
            var obj = document.getElementById(trid);// <TR 찾기
            if (!obj) return;

            // 발주포함
            if (!$('#orderTypesel1').prop('checked') && order_info.smode == 1) {
                obj.style.display = 'none';
                return;
            }

            // 수주포함
            if (!$('#orderTypesel2').prop('checked') && order_info.smode == 2) {
                obj.style.display = 'none';
                return;
            }

            // 완료제외
            if ($('#notshowdone').prop('checked') && window.get_order_payed_type(order_info) == 1) {
                obj.style.display = 'none';
                return;
            }

            // 취소제외
            if ($('#notshowcancel').prop('checked') && order_info.order_status == 99) {
                obj.style.display = 'none';
                return;
            }

            // 발주(직수) 제외
            if ($('#notshowhyunsoo').prop('checked') && order_info.smode == 1 && order_info.pay_method == 2) {
                obj.style.display = 'none';
                return;
            }

            //발주(싸인)제외
            if ($('#notshowsignBaljoo').prop('checked') && order_info.smode == 1 && order_info.pay_method == 1) {
                obj.style.display = 'none';
                return;
            }

            // 날짜 체크
            let start_date = $('#start_date').val();
            let end_date = $('#end_date').val();
            if (order_info.work_day < start_date || order_info.work_day > end_date) {
                obj.style.display = 'none';
                return;
            }

            let is_match = true;

            // 필터링 매칭여부 , 필터링 설정된 컬럼을 돌면서 매칭이 되지 않은게 있으면 스킵한다.
            for (const col in window.orderTax.filter_list) {
                let arr = window.orderTax.filter_list[col];// 컬럼명에 해당되는 필터링 목록
                let idx2 = window.orderTax.show_columns2[col];
                is_match = false;
                arr.forEach((v) => {
                    let data_val = $('#' + trid + ' > td[id=tdx' + idx2 + ']').attr('data_val');
                    if (data_val == v) is_match = true;
                });
            }

            // 검색어 매칭여부
            if (is_match && keyword && keyword.length >= 2) {
                is_match = false;

                var contract_name = order_info.client_name || order_info.bal_print_taxbill_memo || order_info.payed_tome_co_name;
                if (!contract_name) contract_name = '';

                if (order_info.onum.indexOf(keyword) != -1) is_match = true;
                if (order_info.bal_display && order_info.bal_display.indexOf(keyword) != -1) is_match = true;
                if (order_info.bal_owner_phone.indexOf(keyword) != -1) is_match = true;
                if (order_info.site_address.indexOf(keyword) != -1) is_match = true;
                if (contract_name.indexOf(keyword) != -1) is_match = true;
                if (order_info.car_price.indexOf(keyword) != -1) is_match = true;
                if (order_info.car_plate && order_info.car_plate.indexOf(keyword) != -1) is_match = true;
                if (order_info.owner_name && order_info.owner_name.indexOf(keyword) != -1) is_match = true;
                if (order_info.driver_name && order_info.driver_name.indexOf(keyword) != -1) is_match = true;
                if (order_info.worker_display && order_info.worker_display.indexOf(keyword) != -1) is_match = true;
                if (order_info.owner_phone && order_info.owner_phone.indexOf(keyword) != -1) is_match = true;
                if (order_info.driver_phone && order_info.driver_phone.indexOf(keyword) != -1) is_match = true;
            }

            if (!is_match) {
                obj.style.display = 'none';
                return;
            }

            obj.style.display = 'table-row';
            var eaPrice = parseInt(order_info.car_price);
            window.showPriceTotal = parseInt(window.showPriceTotal + eaPrice);
            window.boxOn_showCnt++;
        });

        // 상단바 선택 합계 (레이아웃 #seldPrice — 구 user_top.php total_priceShow)
        $('#seldPrice').text('선택 : ' + Util.formatNumber(window.boxOn_showCnt) + '오더 | 총계 : ' + Util.formatNumber(window.showPriceTotal) + '원');
        var showPrice = document.getElementById("showPrice");
        showPrice.innerHTML = "총 " + Util.formatNumber(window.boxOn_showCnt) + " 개 오더 " + Util.formatNumber(window.showPriceTotal) + "원";
    }

    /** 검색어 입력 디바운스 → search (구 keyword_delay_search) */
    keywordDelaySearch = (event) => {
        clearTimeout(this._kwdTimerId); // 기존 타이머를 취소
        // 디바운싱
        this._kwdTimerId = setTimeout(() => {
            this.search();
        }, G5['DEBOUNCE_TIME']);
    }

    /** 상단 검색옵션 체크박스 상태를 쿠키에 저장 (구 get_checked_search_opt_list) */
    getCheckedSearchOptList = () => {
        let arr = ['Z'];
        if ($('#orderTypesel1').prop('checked')) arr.push('A');//발주
        if ($('#orderTypesel2').prop('checked')) arr.push('B');//수주
        if ($('#notshowdone').prop('checked')) arr.push('C');//완료제외
        if ($('#notshowcancel').prop('checked')) arr.push('D');//취소제외
        if ($('#notshowhyunsoo').prop('checked')) arr.push('E');//발주(직수)제외
        if ($('#notshowsignBaljoo').prop('checked')) arr.push('F');//발주(싸인)제외
        let str = arr.join('');
        Store.cookie.set("userpc_sch_opt", str, { days: 7 * 24 });
    }

    /** 검색 옵션을 가장최근에 저장한 상태로 복원 (구 set_checked_search_opt_list) */
    setCheckedSearchOptList = () => {
        let str = Store.cookie.get('userpc_sch_opt');
        if (!str) str = 'AB'; // 기본값
        if (str.indexOf('A') != -1) $('#orderTypesel1').prop('checked', true);//발주
        if (str.indexOf('B') != -1) $('#orderTypesel2').prop('checked', true);//수주
        if (str.indexOf('C') != -1) $('#notshowdone').prop('checked', true);//완료제외
        if (str.indexOf('D') != -1) $('#notshowcancel').prop('checked', true);//취소제외
        if (str.indexOf('E') != -1) $('#notshowhyunsoo').prop('checked', true);//발주(직수)제외
        if (str.indexOf('F') != -1) $('#notshowsignBaljoo').prop('checked', true);//발주(싸인)제외
    }
}
